import { NotImplementedError } from "../../../../../errors";
import { parseDateFilter } from "../../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_CAMPAIGN_QUERY } from "../query";
export default class LookerOverviewCampaignFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-campaign-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        const advertiserIds = advertiserFilter?.value || [];
        const queryBody = {
            ...FILTER_OPTIONS_CAMPAIGN_QUERY,
            filters: {
                "explore_overview.flt_date_range": parseDateFilter(dateFilter),
                "advertisers.advertiser_id": advertiserIds.join(",")
            }
        };
        const mediaTypeFilter = filters.where?.find((filter) => filter.field === "mediaType");
        if (mediaTypeFilter?.value) {
            queryBody.filters["explore_overview.product_group"] = mediaTypeFilter.value;
        }
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard campaign filter options");
        }));
    }
    formatResponse(data) {
        return data
            .filter((row) => row["campaigns.campaign_id"])
            .map((row) => ({
            id: row["campaigns.campaign_id"],
            name: row["campaigns.campaign_name"] || row["campaigns.campaign_id"]
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Campaign.js.map